import { request } from '@app/http/request'
import { appConfig } from '@app/shared/config'
import type { SpResponse } from '@backend-models/common/request/sp-response'
import type { GetGeneralSettingsResponse } from '@backend-models/general-settings/get/get-general-settings-response'
import type { UpsertGeneralSettingsRequest } from '@backend-models/general-settings/upsert/upsert-general-settings-request'

export const getGeneralSettings = async (hideLoading = false): Promise<SpResponse<GetGeneralSettingsResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/general-settings`, { hideLoading, auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}

export const saveGeneralSettings = async (data: UpsertGeneralSettingsRequest): Promise<SpResponse<GetGeneralSettingsResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/general-settings`, { method: 'POST', json: true, body: JSON.stringify(data), auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}
